import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SignupComponent } from './signup.component';

import { SearchBarModule } from "src/app/modules/shared/_components/search-bar/search-bar.module";

@NgModule({
  declarations: [SignupComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SearchBarModule
  ],
  exports: [SignupComponent]
})
export class SignUpModule { }